import { ApiEmployeeTimeOffCategory } from "@/types/time-off/time-off.types.ts";
import {
  ApiTimeOffCategoryType,
  ApiTimeOffPeriodTrackingTime,
} from "@/types/time-off/time-off-policy.types.ts";
import type { TFunction } from "i18next";

export function getEmployeeTimeOffCategoryCaption(
  category: ApiEmployeeTimeOffCategory,
  t: TFunction
) {
  if (category.category_type === ApiTimeOffCategoryType.flexible) return t("time_off:available");

  const isHours = category.period_track_type === ApiTimeOffPeriodTrackingTime.hours;
  const pluralKey = isHours ? "plurals:plural_hours" : "plurals:plural_day";

  return t(pluralKey, {
    count: parseFloat(category.balance.available_balance),
  });
}
